import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34a975d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-dutch-interval-countdown"
}
const _hoisted_2 = {
  key: 0,
  class: "m-dutch-interval-countdown-inactive m-dutch-interval-countdown-soon"
}
const _hoisted_3 = {
  key: 1,
  class: "m-dutch-interval-countdown-inactive m-dutch-interval-countdown-soon"
}
const _hoisted_4 = {
  key: 2,
  class: "m-dutch-interval-countdown-inactive m-dutch-interval-countdown-soon"
}
const _hoisted_5 = {
  key: 3,
  class: "m-dutch-interval-countdown-inactive m-dutch-interval-countdown-ended"
}
const _hoisted_6 = { key: 4 }
const _hoisted_7 = {
  key: 5,
  class: "m-dutch-interval-countdown-active"
}

import { computed } from "@vue/runtime-core";
import { SalePhase } from "@manifoldxyz/collectible-sdk";
import { useMessaging } from "@/composables/useMessaging";
import { useStore } from "@/composables/useStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'DutchIntervalCountdown',
  setup(__props) {

const store = useStore();
const messaging = useMessaging();
const countdown = computed(() => {
  const getCountdown = {
    // `dutchAuctionCountdown` will always return an object type at runtime
    // the typings are a little wonky and says it could also be a string.
    // @ts-ignore
    ...store.dutchAuctionCountdown,
  };
  return (
    parseInt(getCountdown.days as string) * (24 * 60 * 60) +
    parseInt(getCountdown.hours as string) * (60 * 60) +
    parseInt(getCountdown.minutes as string) * 60 +
    parseInt(getCountdown.seconds as string)
  );
});

return (_ctx: any,_cache: any) => {
  return (_unref(store).loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(store).salePhase === _unref(SalePhase).LOADING)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Loading "))
          : (_unref(store).salePhase === _unref(SalePhase).DEACTIVATED)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(messaging).SALE_PHASE_NOT_ACTIVE), 1))
            : (_unref(store).dutchAuctionHasNotStarted)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(messaging).DUTCH_AUCTION_PUBLIC_SALE_NOT_STARTED), 1))
              : (_unref(store).saleHasEnded)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(messaging).SALE_PHASE_EXPIRED), 1))
                : (_unref(store).dutchAuctionCountdownHasExpired)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(messaging).DUTCH_AUCTION_FINAL_PRICE), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createTextVNode(" Next price drop in "),
                      _createElementVNode("span", null, _toDisplayString(_unref(countdown)), 1)
                    ]))
      ]))
    : _createCommentVNode("", true)
}
}

})